import { QueryHookOptions } from "@apollo/client";

export const lookupOptions: QueryHookOptions = {
    fetchPolicy: "cache-and-network",
};
